export const ADFORM_PREBID_BIDDER = (mid) => ({
  bidder: 'adf',
  params: {
    mid,
  },
});

export const RTBHOUSE_PREBID_BIDDER = {
  bidder: 'rtbhouse',
  params: {
    publisherId: 'kN9ZCLUqTAHaeKouCIGo',
    region: 'prebid-eu',
  },
};

export const YANDEX_PREBID_BIDDER = (placementId) => ({
  bidder: 'yandex',
  params: {
    placementId,
  },
});

export const INDEX_EXCHANGE_BIDDER = (siteId) => ({
  bidder: 'ix',
  params: {
    siteId: `${siteId}`,
  },
});

export const PUBMATIC_PREBID_BIDDER = (adSlot) => ({
  bidder: 'pubmatic',
  params: {
    publisherId: '164073',
    adSlot: `${adSlot}`,
  },
});

export const THEADX_PREBID_BIDDER = (tagId) => ({
  bidder: 'theadx',
  params: {
    pid: 36,
    wid: 148,
    tagId,
  },
});

export const ADMATIC_PREBID_BIDDER = {
  bidder: 'admatic',
  params: {
    networkId: 4013947066,
    host: 'mediazone.rtb.admatic.com.tr',
  },
};

export const ESKIMI_PREBID_BIDDER = {
  bidder: 'eskimi',
  params: {
    placementId: 1453,
  },
};

export const ONEFIFTYTWOMEDIA_PREBID_BIDDER = {
  bidder: 'oftmedia',
  params: {
    placementId: 35842057,
  },
};

export const TEADS_PREBID_BIDDER = {
  bidder: 'teads',
  params: {
    placementId: 244656,
    pageId: 227976,
  },
};
